<div class="chart-container barchart">
    <canvas  id="{{this.chartId}}" >{{ chart }}</canvas>
    <!-- <canvas  id="MyChart" >{{ chart }}</canvas> -->
</div>